import { REGISTER_PARUTION_STRATA } from "../constants/registerParutionStrata";
import { sanitizeRegisterRecencyStratum } from "../constants/registerRecencyStrata";
import { compareEntriesByGradation, getWordGameCount } from "./registerWordListDisplay";

function countMatchesStratum(count, stratum) {
  if (!stratum) return false;

  const n = typeof count === "number" && Number.isFinite(count) ? count : 0;
  const {
    minCountInclusive,
    maxCountInclusive,
    minCountExclusive,
    maxCountExclusive,
  } = stratum;

  if (minCountInclusive != null && n < minCountInclusive) return false;
  if (maxCountInclusive != null && n > maxCountInclusive) return false;
  if (minCountExclusive != null && n <= minCountExclusive) return false;
  if (maxCountExclusive != null && n >= maxCountExclusive) return false;
  return true;
}

export function entryMatchesParutionStratum(entry, stratumId) {
  const id = sanitizeRegisterRecencyStratum(stratumId);
  const stratum = REGISTER_PARUTION_STRATA.find((item) => item.id === id);
  return countMatchesStratum(getWordGameCount(entry), stratum);
}

export function getParutionStratumIdForCount(count) {
  const n = typeof count === "number" && Number.isFinite(count) ? count : 0;
  return REGISTER_PARUTION_STRATA.find((stratum) => countMatchesStratum(n, stratum))?.id ?? "longAgo";
}

/** Filtre + tri pour la strate active. */
export function filterEntriesByParutionStratum(
  entries,
  stratumId,
  { sortByGradation = false, masteredFirst = false } = {}
) {
  return (Array.isArray(entries) ? entries : [])
    .filter((entry) => entryMatchesParutionStratum(entry, stratumId))
    .sort((a, b) => {
      if (sortByGradation) {
        return compareEntriesByGradation(a, b, masteredFirst);
      }

      const countA = getWordGameCount(a);
      const countB = getWordGameCount(b);
      if (countA !== countB) return countB - countA;

      return String(a?.mot || "").localeCompare(String(b?.mot || ""), "fr", {
        sensitivity: "base",
      });
    });
}
